import { ensureAllUserProjectsFetched } from '@modules/projects/stores/projects.thunks'
import { getWorkspacesByUserId } from '@modules/workspaces/stores/workspaces.thunks' /**

 * Loads workspaces and user-wide projects one graft call at a time.
 * Avoids parallel browser WebSocket handshakes that can queue on a single host.
 */
export async function loadInitialWorkspaceAndProjectsSequential(): Promise<void> {
  await getWorkspacesByUserId()
  await ensureAllUserProjectsFetched()
}
